import { jsx } from "react/jsx-runtime";
import { TextField as TextFieldComp } from "@mui/material";
import { useEffect, useState } from "react";
function TextField(props) {
  const { label, value, setField, textfieldProps } = props;
  const [val, setVal] = useState(value);
  useEffect(() => {
    setVal(value);
  }, [value]);
  return /* @__PURE__ */ jsx(
    TextFieldComp,
    {
      fullWidth: true,
      ...textfieldProps,
      "data-testid": "TidalControlsTextField",
      onChange: (e) => {
        setVal(e.target.value);
        setField(label, e.target.value);
      },
      size: "small",
      value: val
    }
  );
}
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
